import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    this.closeOnNavigate = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeOnNavigate)
  }

  toggle() {
    this.sidebarTarget.classList.toggle("-translate-x-full")
    this.overlayTarget.classList.toggle("hidden")
  }

  close() {
    this.sidebarTarget.classList.add("-translate-x-full")
    this.overlayTarget.classList.add("hidden")
  }
}
